export default __webpack_public_path__ + "static/media/example-purchase-page.125d3a5d.png";